
/* eslint-disable @typescript-eslint/restrict-plus-operands */
import React, { memo, useCallback, useContext, useEffect, useRef, useState } from "react";
import { MediaSettingsContext, SettingsContext } from "../../DMSMedia";
import DummyCard from "./DummyCard";

import PinIcon from "@ht/shared/fonts/deos-pis/pin3"

import clsx from "clsx";
import './style.css';
import MicMute from "@ht/shared/fonts/deos-pis/mic-mute";
import MicUnmute from "@ht/shared/fonts/deos-pis/mic";
import TalkIcon from "@ht/shared/fonts/deos-pis/radio";
import { ConferenceContext } from "../..";
import AudioAnalyser from "../visualizer/AudioAnalyzer";
interface IProps {
  srcObject?: any;
  hidePin?: boolean;
  onHandlePin(): void;
  id: string;
  track?: any;
  autoPlay: boolean;
  pinned?: boolean;
  name?: string;
  muted?: boolean;
  style?: any;
  hideTalkingIndicator?: boolean;
  trackAssignment?: any;
  audioTrackAssignment?: any;
  isTiled?: boolean;
}


const VideoCard = memo(({ srcObject, hidePin, onHandlePin, hideTalkingIndicator, pinned, name, trackAssignment, audioTrackAssignment, isTiled, ...props }: IProps) => {

  const timeoutRef: { current: NodeJS.Timeout | null } = useRef(null);
  //const mediaSettings = useContext(MediaSettingsContext);
  const settings = useContext(SettingsContext);
  const conference = useContext(ConferenceContext);
  const [displayHover, setDisplayHover] = React.useState(false);
  //const { setParticipants, participants } = mediaSettings;
  const [isVideoOff, setIsVideoOff] = useState(false);
  const [srcobj, setSrcobj] = useState<MediaStream>();

  const isJsonString = (str: string) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
  const parseMetaDataAndGetIsMicMuted = (metaData: any) => {
    if (!metaData) return true;
    return (isJsonString(metaData)) ? JSON.parse(metaData).isMicMuted : true;
  }
  function parseMetaDataAndGetIsCameraOn(metaData: any) {
    if (!metaData) return false;
    return (isJsonString(metaData)) ? JSON.parse(metaData).isCameraOn : false;
  }

  function parseMetaDataAndGetIsScreenShared(metaData: any) {
    if (!metaData) return false;
    return (isJsonString(metaData)) ? JSON.parse(metaData).isScreenShared : false;
  }
  const micMuted = (trackAssignment.isMine) ? conference?.isMyMicMuted : parseMetaDataAndGetIsMicMuted(conference?.allParticipants[trackAssignment.streamId]?.metaData);
  const camTurnedOff = (trackAssignment.isMine) ? conference?.isMyCamTurnedOff : !parseMetaDataAndGetIsCameraOn(conference?.allParticipants[trackAssignment.streamId]?.metaData);

  const refVideo = useCallback(

    (node) => {
      if (node && trackAssignment.track) {

        node.srcObject = new MediaStream([trackAssignment.track]);
        node.play().then(() => { }).catch((e: any) => { console.log("play failed because ", e) });
      }
      if (node && audioTrackAssignment && audioTrackAssignment.length > 0 && camTurnedOff) {
        node.srcObject = new MediaStream([audioTrackAssignment[0].track]);
        node.play().then(() => { }).catch((e: any) => { console.log("play failed because ", e) });
        setSrcobj(node.srcObject)
      }
    },
    [trackAssignment.track, camTurnedOff]
  );
  // React.useEffect(() => {
  //   if (props.track?.kind === "video" && !props.track.onended) {
  //     props.track.onended = (event: any) => {
  //       if (participants.length > settings?.globals?.maxVideoTrackCount) {
  //         setParticipants((oldParts: any) => {
  //           return oldParts.filter(
  //             (p: any) => !(p.id === props.id || p.videoLabel === props.id)
  //           );
  //         });
  //       }
  //     };
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [trackAssignment.track]);
  if (trackAssignment.isMine) {
    //useAvatar = conference?.isMyCamTurnedOff;
  }
  else if (trackAssignment.track?.kind === "video") {
    const broadcastObject = conference?.allParticipants[trackAssignment.streamId];
    const metaData = broadcastObject?.metaData;
    //useAvatar = !parseMetaDataAndGetIsCameraOn(metaData) && !parseMetaDataAndGetIsScreenShared(metaData);
  }
  
  const [isTalking, setIsTalking] = React.useState(false);

  const mirrorView = trackAssignment?.isMine && !conference?.isScreenShared;
  // const isScreenSharing =
  // conference?.isScreenShared ||
  //   mediaSettings?.screenSharedVideoId === props?.id;

  //mediaSettings?.isScreenShared means am i sharing my screen
  //mediaSettings?.screenSharedVideoId === props?.id means is someone else sharing their screen
  useEffect(() => {
    if (trackAssignment.isMine && conference.isPublished && !conference.isPlayOnly) {
      conference.setAudioLevelListener((value: any) => {
        // sounds under 0.01 are probably background noise
        if (value >= 0.01) {
          if (isTalking === false) setIsTalking(true);
          clearInterval(timeoutRef.current as NodeJS.Timeout);
          timeoutRef.current = setTimeout(() => {
            setIsTalking(false);
          }, 1500);
        }
      }, 1000);
    }

  }, [conference.isPublished]);
  const [isThisTalking, setIsThisTalking] = useState(false)

  const avatarOrPlayer = () => {
    return (
      <>
        <div
          className={clsx("h-[100%] bg-gray-200 rounded-lg p-0 md:p-5", !camTurnedOff && "hidden")} /*ini dibalik !isVideoOff*/
        >
          <DummyCard name={name ?? ""} srcobj={srcobj} />
        </div>
        <div
          className={clsx("h-[100%] bg-transparent", mirrorView && "mirror", camTurnedOff && "hidden")}/*ini dibalik isVideoOff*/
        >
          <video
            className={clsx("draggable w-[100%] h-[100%] center"
              //, (conference?.screenSharedVideoId === props?.id) ? "object-contain" : "xsToSm:object-contain object-cover"
              , { "rounded-lg": !pinned }, { "max-h-[300px]": isTiled })}
            {...props}
            ref={refVideo}
            playsInline
            id={trackAssignment.streamId}
            style={{ objectFit: pinned ? "contain" : "cover" }}
            muted={trackAssignment.isMine}
          >
            <track src="captions_en.vtt" kind="captions" srcLang="en" label="english_captions"></track>
          </video>
        </div>
      </>
    )
  }

  const setLocalVideo = () => {
    const tempLocalVideo = document.getElementById((typeof conference?.publishStreamId === "undefined") ? "localVideo" : conference?.publishStreamId);
    if (trackAssignment.isMine && conference.localVideo !== tempLocalVideo) {
      conference?.localVideoCreate(tempLocalVideo);
    }
  };
  const overlayVideoTitle = () => {
    return (
      <div className={
        clsx("max-w-[60%] h-[14px] md:h-[24px] text-[10px] md:text-[12px] absolute bottom-2 left-2 font-semibold flex flex-row gap-1 items-center justify-center rounded bg-black bg-opacity-[0.4] text-white px-[4px] ",
          { "hidden": pinned },
        )
      }>
        <span className="truncate">{name == 'videolocal' ? 'You' : name}</span>
      </div >
    )
  }

  const isTalkingFrame = () => {
    return (
      <div
        className={clsx("flex flex-row-reverse absolute z-[999]", { "top-[10%] md:top-[50px] left-[10px]": pinned, "top-[5px] left-[5px]": !pinned })}>
        {micMuted ? (
          <div className={clsx("flex flex-row items-center justify-center rounded-lg bg-black bg-opacity-[0.4] text-white h-[24px] gap-[2px] px-[4px]")}>
            <MicMute className={clsx(" w-3 md:w-4 h-3 md:h-4")} />
          </div>
        ) :
          <div
            className={clsx("talking-indicator-light", !((isTalking || isThisTalking)) && "hidden", hideTalkingIndicator && "hidden")}
          >
            <div className={clsx("flex flex-col items-center justify-center rounded-lg bg-white w-[20px] h-[20px]")}>
              <TalkIcon className={clsx("text-primary w-[18px] h-[18px]")} />
            </div>
          </div>
        }
      </div>
    );
  }

  return (trackAssignment?.isMine || trackAssignment?.track.kind !== "audio") ? (
    <>
      <div role={"button"}
        tabIndex={0}
        className="w-[100%] h-[100%] relative"

        onMouseEnter={() => setDisplayHover(true)}
        onMouseLeave={(e) => setDisplayHover(false)}
      >

        {!hidePin && (
          <div
            className={clsx("flex flex-col justify-center items-center rounded-lg absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 m-auto z-[98] transition-opacity",
              displayHover && "opacity-100",
              !displayHover && "opacity-0",

            )}

          >

            <div role={"button"} tabIndex={-1} onKeyDown={onHandlePin}
              onClick={onHandlePin}
              color="primary"
              aria-label="add"
            >

              {!pinned &&
                <div className="flex items-center justify-center w-[36px] h-[36px] bg-white rounded-full opacity-[0.5]">
                  <PinIcon className="w-5 h-5 text-black"></PinIcon>
                </div>
              }
            </div>

          </div>
        )}

        <div className={`single-video-card h-[100%] w-[100%]`}>



          {avatarOrPlayer()}

          {setLocalVideo()}

          {/* {overlayParticipantStatus()} */}

          {isTalkingFrame()}
          {overlayVideoTitle()}

        </div>
      </div>
    </>
  ) : (
    <>
      <video
        style={{ display: "none" }}
        {...props}
        ref={refVideo}
        playsInline
      >
        <track src="captions_en.vtt" kind="captions" srcLang="en" label="english_captions"></track>
      </video>
    </>
  );
});

VideoCard.displayName = 'Video Card';
export default VideoCard;